const LAST_VISIT_PREFIX = "gitcha-widget-last-visit:";

export const parseServerTime = (value) => {
  if (!value) return null;
  const text = String(value).trim();
  const iso = /[zZ]|[+-]\d\d:?\d\d$/.test(text)
    ? text
    : `${text.replace(" ", "T")}Z`;
  const parsed = new Date(iso);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const readLastVisit = (widgetKey, storage) => {
  try {
    const store = storage || window.localStorage;
    const raw = store.getItem(LAST_VISIT_PREFIX + widgetKey);
    if (!raw) return null;
    const parsed = new Date(raw);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  } catch (error) {
    return null;
  }
};

export const writeLastVisit = (widgetKey, now = new Date(), storage) => {
  try {
    const store = storage || window.localStorage;
    store.setItem(LAST_VISIT_PREFIX + widgetKey, now.toISOString());
    return true;
  } catch (error) {
    return false;
  }
};

const publishedAt = (ad) => parseServerTime(ad?.PublishedOn || ad?.CreatedOn);

export const newSinceLastVisit = (ads = [], lastVisit) => {
  if (!lastVisit || ads.length === 0) return null;
  const newer = ads.filter((ad) => {
    const at = publishedAt(ad);
    return at && at > lastVisit;
  });
  if (newer.length === 0) return null;
  return {
    count: newer.length,
    atLeast: newer.length === ads.length,
    ids: newer.map((ad) => ad.Want_ad_Id),
    onlySlug: newer.length === 1 ? newer[0].slug || null : null,
  };
};

const plural = (count, one, many) => (count === 1 ? one : many);

export const newSinceLabel = ({ count, atLeast }) =>
  `${count}${atLeast ? "+" : ""} new Buyer ${plural(
    count,
    "Want-Listing",
    "Want-Listings",
  )} since your last visit`;

const SMALL_MARKET_MAX = 40;

export const countFloor = (marketSize) =>
  marketSize <= SMALL_MARKET_MAX ? 2 : 5;

export const marketLine = (totalCount, marketName) => {
  const where = marketName ? ` in ${marketName}` : "";
  if (!totalCount) return `Buyer Want-Listings${where}`;
  if (totalCount < countFloor(totalCount)) {
    return `Buyer Want-Listings are live${where}`;
  }
  return `${totalCount} Buyer ${plural(
    totalCount,
    "Want-Listing",
    "Want-Listings",
  )} live${where}`;
};
